import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const netlas = defineConnector({
  identifier: "netlas",
  name: "Netlas",
  tagLine: "Internet intelligence and attack surface discovery",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://app\\.netlas\\.io/.*",
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Netlas](https://app.netlas.io/) and navigate to your profile to find your API key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.netlas.io/api/users/current/",
  },
});
